
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-agent",
      function () {
        return require("private-next-pages/become-agent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-agent"])
      });
    }
  